define('RunOnEveryPage/components/goToPageSection',[
],
    function () {
        function init() {
            $(document).ready(function ($) {
                $('a[href^="#"]').on("click", function (e) {
                    e.preventDefault();
                    scrolltoAnchor($(this).attr("href"));                    
                });
            });
        }

        function scrolltoAnchor(anchor) {
            if (!anchor.startsWith("#"))
                anchor = "#" + anchor;
            var stickyElements = $(".sticky-container");
            var stickyOffset = 0;
            if (stickyElements && stickyElements.length > 0) {
                stickyElements.each(function () {
                    stickyOffset += $(this)[0].offsetHeight;
                });
            }           
            var elementOffset = $(anchor).offset();
            window.scrollTo(elementOffset.left, elementOffset.top - stickyOffset);
        }

        window.ScrollToAnchor = scrolltoAnchor;

        return {
            init: init            
        };
    }
);

